import { Pipe, PipeTransform } from '@angular/core';
import { Option } from '@dch/products-business-logic';

@Pipe({
  name: 'excludeNetflixBuyAndSell',
})
export class ExcludeNetflixBuyAndSellPipe implements PipeTransform {
  transform(values: Array<Option>, showBuyAndSell: boolean): any {
    if (!showBuyAndSell) {
      return (values || []).filter(
        (v) => v.optionCodeForDescription !== 'MKIWR',
      );
    } else {
      return values;
    }
  }
}
